import produce from 'immer'

import { CLEANUP_MENU_DATA, FETCH_MENU_DATA } from '../action-types'
import { MENU_DATA_INITIAL_STATE } from '../initial-states'

const menuDataReducer = (state = MENU_DATA_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MENU_DATA.START:
      return produce(state, nextState => {
        nextState.isLoading = true
        nextState.error = null
        nextState.data = null
      })

    case FETCH_MENU_DATA.COMPLETE:
      return produce(state, nextState => {
        nextState.isLoading = false
        nextState.data = action.payload.data.menuData
      })

    case FETCH_MENU_DATA.FAIL:
      return produce(state, nextState => {
        nextState.isLoading = false
        nextState.error = action.payload.error
      })

    case CLEANUP_MENU_DATA:
      return MENU_DATA_INITIAL_STATE

    default:
      return state
  }
}

export default menuDataReducer
